const endPointsSections = {
    courses: "courses",
    // myCourses: "myCourses",
    environments: "environments",
    mySchoolCourses: "mySchoolCourses",
    mySelfLearning: "mySelfLearning",
    myAssessment: "myAssessment",
    calendar: "calendar",
    myMatriculationEvents: "myMatriculationEvents",
    // myFlexibleMatriculationCourses: "myFlexibleMatriculationCourses"
}
export default endPointsSections